import { getters } from "@/constants/state";

export default {
  [getters.SHIFT_REQUESTS_PENDING_GETTER]: (state) =>
    state.pendingShiftRequests,
  [getters.SHIFT_REQUESTS_HISTORY_GETTER]: (state) =>
    state.shiftRequestsHistory,
};
